import { Star } from "@phosphor-icons/react";
import { useInView, useCountUp } from "@/hooks/useInView";

const stats = [
  { raw: "5.0", label: "Five-Star Google Reviews", isRating: true, isDecimal: true },
  { raw: "15", label: "Years of Experience", suffix: "+" },
  { raw: "40", label: "Person Workshops", suffix: "+", prefix: "Up to " },
  { text: "Private to Group", label: "Sessions & Workshops", isText: true },
];

function AnimatedStat({ stat, active }) {
  const num = parseFloat(stat.raw || "0");
  const count = useCountUp(num, 1500, active);

  if (stat.isText) {
    return (
      <p className="font-heading text-xl sm:text-2xl font-black text-[#D4AF37] tracking-tight leading-tight">
        {stat.text}
      </p>
    );
  }

  if (stat.isRating) {
    const display = active ? (stat.isDecimal ? (count === 0 ? "0.0" : num.toFixed(1)) : count) : "0.0";
    return (
      <div className="flex items-center justify-center gap-2">
        <p className="font-heading text-3xl sm:text-4xl font-black text-[#D4AF37] tracking-tight tabular-nums">{display}</p>
        <div className="flex flex-col items-start gap-0.5">
          <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} size={12} weight="fill" className="text-[#D4AF37]" />)}
          </div>
          <span className="text-[10px] text-[#8C8C8C] font-body">(77)</span>
        </div>
      </div>
    );
  }

  return (
    <p className="font-heading text-3xl sm:text-4xl font-black text-[#D4AF37] tracking-tight tabular-nums">
      {stat.prefix || ""}{active ? count : "0"}{stat.suffix || ""}
    </p>
  );
}

export default function TrustBar() {
  const [ref, inView] = useInView();

  return (
    <section data-testid="trust-bar" className="bg-[#111111]/80 backdrop-blur-md border-y border-white/10" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s, i) => (
            <div
              key={s.label}
              data-testid={`trust-stat-${s.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`text-center reveal ${inView ? 'visible' : ''} stagger-${i + 1}`}
            >
              <AnimatedStat stat={s} active={inView} />
              <p className="text-xs tracking-[0.15em] uppercase text-[#8C8C8C] font-body mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
